import React, { ChangeEvent, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useFormikContext } from 'formik';

import { UpdateUserManagementUserProfileInput, UserType } from 'api';

const useStyles = makeStyles(() => ({
  dropdown: {
    minWidth: 140,
  },
}));

const RoleDropdown: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext<UpdateUserManagementUserProfileInput>();

  const [open, setOpen] = useState(false);

  function onChange(event: ChangeEvent<HTMLSelectElement>) {
    const { value } = event.target;
    setFieldValue('user_type', value);
  }

  return (
    <Grid item container alignItems="center">
      <Grid item xs={3}>
        <Typography variant="body2">{t('admin:role')}</Typography>
      </Grid>

      <Grid item xs={8}>
        <Select
          className={classes.dropdown}
          open={open}
          value={values.user_type}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          onChange={onChange}
        >
          <MenuItem value={UserType.Admin}>{t('common:admin')}</MenuItem>
          <MenuItem value={UserType.Cs}>{t('common:moderator')}</MenuItem>
          <MenuItem value={UserType.Contributor}>{t('common:contributor')}</MenuItem>
          <MenuItem value={UserType.User}>{t('common:user')}</MenuItem>
        </Select>
      </Grid>
    </Grid>
  );
};

export default RoleDropdown;
